import {
  SignalCategories,
  SignalGroupMemberTypes,
  SignalNoticeTypes,
  SignalThresholdLevels
} from "applications/signal/constants";

/**
 * noticeTypeのidからラベルを取得する
 * @param type
 * @returns
 */
export function noticeTypeLabel(type: number): string {
  const typeObj = SignalNoticeTypes.find(t => t.id === type);
  return typeObj ? typeObj.label : "不明なタイプ";
}

/**
 * signalTypeのordinalからラベルを取得する
 * @param signalType
 * @returns
 */
export function signalTypeLabel(signalType: number): string {
  let label = "不明なタイプ";
  for (const [categoryKey, category] of Object.entries(SignalCategories)) {
    for (const [typeKey, type] of Object.entries(category.types)) {
      if (type.ordinal === signalType) {
        label = type.label;
        break;
      };
    }
  }
  return label;
}

/**
 * thresholdLevelのidからラベルを取得する
 * @param level
 * @returns
 */
export function thresholdLevelLabel(level: number): string {
  const levelObj = SignalThresholdLevels.find(l => l.id === level);
  return levelObj ? levelObj.label : "不明なレベル";
}

/**
 * memberTypeのordinalからラベルを取得する
 * @param memberType
 * @returns
 */
export function groupMemberTypeLabel(memberType: number): string {
  const memberTypeObj = Object.values(SignalGroupMemberTypes).find(mt => mt.ordinal === memberType);
  return memberTypeObj ? memberTypeObj.label : "不明な種別";
}
